import { MessageDirection, MessagePosition } from '../message';

export type ToastSize = 'large' | 'medium';
export type ToastStatus = 'info' | 'success' | 'error';
export const ToastPosition = MessagePosition;
export type ToastPositionType = (typeof ToastPosition)[keyof typeof ToastPosition];
export type ToastDirection = MessageDirection;
